import { Button } from "@mui/material"
import { useSelector } from 'react-redux';
function lightenColor(color, percent) {
  const num = parseInt(color?.replace("#", ""), 16);
  const r = (num >> 16) + Math.round(255 * percent);
  const g = ((num >> 8) & 0x00ff) + Math.round(255 * percent);
  const b = (num & 0x0000ff) + Math.round(255 * percent);

  return (
    "#" +
    (
      0x1000000 +
      (r < 255 ? r : 255) * 0x10000 +
      (g < 255 ? g : 255) * 0x100 +
      (b < 255 ? b : 255)
    )
      .toString(16)
      .slice(1)
  );
}
export default function Btn({
  className,
  variant,
  click,
  content: Content,
  disabled,
  sx,
  loading,
  color // default to Material Blue
}) {
  const isOutline = variant === "outline";

  return (
    <Button
      type="button"
      className={`${className} min-w-0 focus:outline-none shadow-none hover:shadow-none ${disabled ? "opacity-50" : ""
        }`}
      style={{ textTransform: "capitalize" }}
      variant={isOutline ? "outlined" : "contained"}
      onClick={disabled ? null : click}
      disabled={disabled || loading}
      sx={{
        ...(isOutline
          ? {
            backgroundColor: "white",
            color: color,
            border: `1px solid ${color}`,
            "&:hover": {
              backgroundColor: lightenColor(color,.1),
              color: "white"
            }
          }
          : {
            backgroundColor: `${color} !important`,
            color: "white",
            "&:hover": {
              backgroundColor: "#155fa0" // slightly darker shade (can be customized)
            }
          }),
        ...sx
      }}
    >
      {!loading ? (
        typeof Content === "function" ? (
          <Content />
        ) : (
          Content
        )
      ) : (
        <Loader />
      )}
    </Button>
  );
}



export function FormBtn({ variant, className, disabled, click, sx, content: Content }) {
  const { formLoading } = useSelector(state => state.misc);

  return (
    <Button
      className={`${className} focus:outline-none ${(disabled || formLoading) ? 'bg-opacity-50' : ''}`}
      style={{ textTransform: 'capitalize' }}
      variant={variant ?? 'contained'}
      onClick={click}
      type="submit" sx={sx}
      disabled={disabled || formLoading}
    >
      {
        formLoading ? (
          <Loader />
        ) : (
          <>
            {
              typeof (Content) === 'function' ? (
                <Content />
              ) : Content
            }
          </>
        )
      }
    </Button>
  )

}



export const Loading = ({ className }) => {
  return (
    <div className="">
      <svg className={`animate-spin ${className} text-primary`} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">

        <circle className="opacity-25" cx={12} cy={12} r={10} stroke="currentColor" strokeWidth={4} />
        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
      </svg>
    </div>
  )
}

export const Loader = () => {
  return (
    <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <circle className="opacity-25" cx={12} cy={12} r={10} stroke="currentColor" strokeWidth={4} />
      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
    </svg>
  )
}